import { company } from '../../mock';
import { MapPin, ExternalLink } from 'lucide-react';

export default function Map() {
  const mapSrc =
    'https://www.google.com/maps?q=81+Vogel+Street,+Woodville,+New+Zealand&output=embed';
  const directionsUrl =
    'https://www.google.com/maps/dir/?api=1&destination=81+Vogel+Street,+Woodville,+New+Zealand';

  return (
    <section aria-label="Office location" className="pb-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="rounded-3xl overflow-hidden border border-stone-200 shadow-[0_30px_60px_-40px_rgba(0,0,0,0.2)] bg-white">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 px-6 py-5 border-b border-stone-200">
            <div className="flex items-start gap-3">
              <div className="h-10 w-10 rounded-xl bg-[#0b6b5b]/10 grid place-items-center text-[#0b6b5b] flex-shrink-0">
                <MapPin className="h-5 w-5" />
              </div>
              <div>
                <div className="font-display font-semibold text-stone-900">
                  Find us in Woodville
                </div>
                <div className="text-sm text-stone-600">{company.address}</div>
              </div>
            </div>
            <a
              href={directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#0b6b5b] hover:underline self-start md:self-auto"
            >
              Get directions <ExternalLink className="h-4 w-4" />
            </a>
          </div>
          <iframe
            title="Ask Away Accounting office location map"
            src={mapSrc}
            width="100%"
            height="420"
            style={{ border: 0, display: 'block' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
